<template>
  <v-row no-gutters class="mt-1">

    <v-col v-if="getenableADA" class="d-flex my-2 justify-center align-center" cols="12">
      <span class="text-h3 font-weight-bold">
        {{ getPageHeader }}
      </span>
    </v-col>

    <v-col cols="3" align-self="center">
      <v-card height="725" flat class="containerBorder mx-3">
        <v-card-title class="d-flex justify-center font-weight-bold primary--text">
          {{ $t('header') }}
        </v-card-title>
        <v-divider class="mx-3"></v-divider>
        <v-card class="overflow-y-auto" height="630" flat>
          <v-list text>
            <v-list-item-group>
              <v-list-item v-for="(item, i) in maps" :key="i" color="primary"
                @click="selectImage(item.mapImage, item.mapFloor, item.speech, item.mapName);">
                <v-list-item-content>
                  <v-card min-height="45" @click="selectedMap = item.mapName"
                    class="pa-0 ma-0 text-wrap white--text text-left"
                    v-bind:color="item.mapName === selectedMap ? '#d37444' : 'primary'">
                    <v-card-title class="text-subtitle-1 font-weight-bold">
                      {{
                        item.mapName.toUpperCase() | trimLength
                      }}
                    </v-card-title>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-card>
    </v-col>
    <v-col cols="9">
      <v-card height="725" flat>
        <v-tabs background-color="primary" dark active-class="tabClass" v-model="active_tab" height="70" centered>
          <v-tab v-for="(floor, i) in floors" :key="i" align="center" class="text-subtitle-1 font-weight-bold pa-5"
            @click="
              selectImage(
                floor.floorImage.url,
                floor.floorNumber,
                floor.speech,
                floor.floorName
              );">
            {{ floor.floorName }}
          </v-tab>
        </v-tabs>
        <v-row>
          <v-col align="center" cols="12">
            <v-img :src="url" width="84%" contain></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "maps",
  data() {
    return {
      active_tab: 1,
      url: "",
      floorNum: null,
      showList: false,
      selectedMap: '',
      count: 0,
    };
  },
  computed: {
    ...mapGetters(["getMaps", "getCMSlink", "getAvatarLangCodes", "getSessionId", "getKioskProfile", "getPageHeader", "getenableADA"]),
    maps() {
      // Fetch maps and store them temporarily
      let temp = this.$i18n.t("maps").map((map) => {
        // console.log(map, "this is map");
        return map;
      });

      // Group by mapFloor and sort by mapFloor and mapName
      return temp.sort((a, b) => {
        if (a.mapFloor === b.mapFloor) {
          // Sort alphabetically by mapName if mapFloor is the same
          return a.mapName.localeCompare(b.mapName);
        }
        // Sort by mapFloor (ascending order)
        return a.mapFloor - b.mapFloor;
      });
    },
    floors() {
      return this.$i18n.t('floors').sort((a, b) => a.floorNumber - b.floorNumber)
    },
    adjustedHeight() {
      return this.getenableADA ? 635 : 785; // Increase height when ADA is enabled
    },
    adjustedInnerHeight() {
      return this.getenableADA ? 525 : 675; // Adjust inner card height accordingly
    },
    adjusted() {
      return this.getenableADA ? '100%' : '100%';
    }
  },


  methods: {
    filterMaps(category) {
      let temp = []
      this.$i18n.t("maps").forEach(map => {
        if (map.category === category) {
          temp.push(map)
        }
      })
      return temp
    },
    selectImage(mapPath, mapFloor, speech, mapName) {
      let date = new Date()
      this.active_tab = mapFloor;
      this.url = mapPath;
      console.log(mapPath,mapFloor,speech,mapName,"This is the mapPath,mapFloor,speech,mapName");
      // Condition added to avoid redundant call from Mounted
      if (speech !== undefined) {
        this.$store.commit("setSpeechRecognitionHandler", false);
        this.$store.commit("setIsThinking", false)
        this.$store.commit('setRequestQna', false)
        //this.$store.dispatch("avatarSpeak", speech);
        // this.$store.commit('setTextBubbleText', speech);

        this.$store.dispatch('avatarTalk', speech);

        //session-data
        // Touch Usage
        this.$store.dispatch('addSessionDataToStrapi', {
          applicationId: this.getKioskProfile.data().applicationId,
          actionType: 'Touch',
          applicationSessionId: this.getSessionId,
          timeStamp: date.toISOString(),
          sessionPayload: {
            module: "Maps",
            action: "View Map",
            response: mapName,
            timeStamp: date.toISOString()
          }
        })

        this.$store.dispatch('addInteractionToPostgres', {
          actionType: 'Interaction',
          actionPayload:
            { module: 'Maps', navigateFrom: 'Maps', navigateTo: 'Maps', interactionType: 'Touch', elementContent: mapName }
        })

      
        
      }
    },
    showMaps(num) {
      if (this.floorNum === num) {
        this.showList = false;
        this.floorNum = 0;
      } else {
        this.floorNum = num;
        this.showList = true;
      }
    },
    showDepartment(depart) {
      this.$store.commit("setDepartmentServiceViewer", {
        show: true,
        departmentName: depart.departmentName,
        services: depart.object.departments.deptCategory
      })
    }
  },
  filters: {
    trimLength(val) {
      if (val.length < 40) {
        return val;
      }
      return `${val.substring(0, 35)}...`;
    },
  },
  mounted() {
    this.$i18n.t("floors").forEach(floor => {
      if (floor.defaultLocation) {
        console.log(floor,"Check this");
        this.selectImage(floor.floorImage.url, floor.floorNumber)
      }
    })
  },
};
</script>
<i18n>
{
  "en": {
      "header": "MAP DIRECTORY"
    },
  "es":{
      "header": "Directorio Mapas"
    }
}
</i18n>
<style scoped>
.containerBorder2 {
  border-radius: 0px !important;
}
</style>